import { jsxs as n, jsx as s } from "react/jsx-runtime";
import { useState as p } from "react";
import "../../form-elements/input/input.js";
import x from "../../form-elements/dynamic-form/dynamic-form.js";
import "../../form-elements/file-upload/file-upload.js";
import w from "../../form-elements/select/select.js";
import { isArrayWithItems as A } from "../../../helpers/array-helper.js";
import "dayjs";
import "@radix-ui/react-slider";
import c from "./company-forms.js";
import D from "./forms-block-wrapper.js";
import { usePostCustomerServiceCompanyServiceNow as P } from "../../../react-query-queries/customer-service/use-post-customer-service-service-now.js";
import { getErrorsFromApiError as V } from "../../../helpers/form-helper.js";
const z = ({ title: b, preamble: d }) => {
  const [t, g] = p(Object.keys(c)[0]), [a, i] = p(), y = Object.entries(c).map(([r, m]) => ({
    label: m.label,
    value: r
  })), u = t ? c[t] : null, { mutateAsync: h, isPending: f } = P(), k = (r, { reset: m }) => {
    const { attachedFiles: F, termsAccepted: B, ...o } = r;
    let e = {};
    t === "addresschange" ? e = {
      ...o,
      subCategory: "Address/Name Change",
      subject: `${o.subCategory}`
    } : t === "swedishHaulers" ? e = {
      ...o,
      subCategory: "Rebate"
    } : e = {
      ...o
    };
    const v = typeof e.subCategory == "string" && e.subCategory.indexOf("#") > -1 ? e.subCategory.split("#")[0] : e.subCategory, S = {
      invoiceNumber: e.invoiceNumber,
      customerNumber: e.customerNumber,
      cardNumber: e.cardNumber,
      cardListType: e.cardListType,
      organisationNumber: e.organisationNumber,
      swedishHaulerNumber: e.swedishHaulerNumber,
      subCategory: v,
      firstName: e.firstName,
      lastName: e.lastName,
      phone: e.phone,
      email: e.email,
      requestType: t ?? "",
      description: e.description,
      subject: e.subject,
      attachedFiles: F,
      termsAccepted: !0
    };
    h(S).then(() => {
      i({
        type: "success",
        heading: "Ditt ärende är skickat",
        messages: [
          {
            text: "Ditt supportärende är nu registrerat hos oss. Vi arbetar med att hantera alla inkommande ärenden och kommer att kontakta dig inom kort för att hjälpa dig vidare."
          }
        ]
      }), m({ description: "" }, { keepDefaultValues: !0 });
    }).catch((j) => {
      const l = V(j);
      A(l) ? i({
        type: "error",
        heading: "Misslyckades med att skicka in ärendet",
        messages: l
      }) : i({
        type: "error",
        heading: "Problem med bakomliggande system",
        messages: [
          {
            text: "Det gick tyvärr inte att skicka in ditt ärende. Om det fortsatt inte går kontakta kundservice@preem.se."
          }
        ]
      });
    });
  }, N = t === "edi", C = `${t}-${a ? a.toString() : "no-key"}`;
  return /* @__PURE__ */ n(D, { children: [
    /* @__PURE__ */ n("div", { className: "text-max-width", children: [
      /* @__PURE__ */ s("h3", { children: b }),
      d && /* @__PURE__ */ s("div", { children: d })
    ] }),
    /* @__PURE__ */ n("div", { className: "form-max-width", children: [
      /* @__PURE__ */ s(
        w,
        {
          label: "Välj ärendetyp",
          value: t,
          onChange: (r) => g(r),
          items: y
        }
      ),
      u ? /* @__PURE__ */ s(
        x,
        {
          form: u.form,
          onFormSubmit: k,
          formStatus: a,
          isPostingForm: f,
          hideSubmitButton: N
        },
        C
      ) : /* @__PURE__ */ s("p", { children: "Välj ärendetyp först" })
    ] })
  ] });
};
export {
  z as default
};
